/**
 * toggleUpsellVisibility checks if the upsell element exists and toggles its
 * visibility by adding/removing the 'hidden' class based on if there are upsell
 * items or not.
 *
 * upsellNavigation sets up the event listeners and logic for handling
 * navigation of the upsell slider/carousel. It handles click events on the next/
 * prev buttons, mouse drag scrolling, and some view state based on number of
 * items.
 */

// Function to toggle upsell visibility based on the presence of upsell items
function toggleUpsellVisibility() {
  const targetNode = document.querySelector('[data-name="upsell"]');
  if (!targetNode) return;
  const upsellElement = document.querySelector('[data-name="upsell"]');
  const upsellItems = document.querySelector(".upsell__item");
  if (!upsellItems) {
    upsellElement.classList.add("hidden");
  } else {
    upsellElement.classList.remove("hidden");
  }
}

function upsellNavigation() {
  const productContainer = document.querySelector(".upsell__slider");
  const nxtBtn = document.querySelector(".nxt-btn");
  const preBtn = document.querySelector(".pre-btn");
  const upsellBtns = document.querySelector('[data-name="upsell-buttons"]');
  const upsellCartItems = document.querySelectorAll(".upsell__item");

  if (productContainer) {
    function updateButtons() {
      const maxScrollLeft = productContainer.scrollWidth - productContainer.clientWidth;
      preBtn.disabled = productContainer.scrollLeft <= 0;
      nxtBtn.disabled = productContainer.scrollLeft >= maxScrollLeft;

      preBtn.classList.toggle("disabled", productContainer.scrollLeft <= 0);
      nxtBtn.classList.toggle("disabled", productContainer.scrollLeft >= maxScrollLeft);
    }

    if (nxtBtn) {
      nxtBtn.addEventListener("click", function () {
        productContainer.scrollLeft += 240;
        setTimeout(updateButtons, 400);
      });
    }
    if (preBtn) {
      preBtn.addEventListener("click", function () {
        productContainer.scrollLeft -= 240;
        setTimeout(updateButtons, 400);
      });
    }

    const ele = productContainer;
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {
      ele.style.cursor = "grabbing";
      ele.style.userSelect = "none";
      pos = { left: ele.scrollLeft, x: e.clientX };
      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
      const dx = e.clientX - pos.x;
      ele.scrollLeft = pos.left - dx * 2;
    };

    const mouseUpHandler = function () {
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);
      ele.style.cursor = "grab";
      ele.style.userSelect = "";
    };

    ele.addEventListener("mousedown", mouseDownHandler);
    const upsellSlideCartItems = document.querySelectorAll(".upsell__slider .upsell__item");
    if (upsellSlideCartItems.length === 1) {
      document.querySelector(".upsell").classList.add("one-item-in-cart");
    } else if (upsellSlideCartItems.length < 1) {
      document.querySelector(".upsell").classList.add("no-item-in-cart");
    } else {
      document.querySelector(".upsell").classList.remove("one-item-in-cart", "no-item-in-cart");
    }

    function removeDuplicates() {
      if (upsellCartItems.length <= 3) {
        upsellBtns.classList.add("hidden");
      } else {
        upsellBtns.classList.remove("hidden");
      }
      const upsellItems = document.querySelectorAll(".line-item");
      const uniqueItems = [];
      upsellItems.forEach((item) => {
        const itemValue = item.getAttribute("value");
        if (!uniqueItems.includes(itemValue)) {
          uniqueItems.push(itemValue);
        } else {
          const duplicateItem = document.querySelector(`.line-item.${itemValue}`);
          if (duplicateItem) {
            duplicateItem.remove();
          }
        }
      });
    }
    removeDuplicates();
    // setTimeout(updateButtons, 500);

    productContainer.addEventListener("scroll", updateButtons);
  }
}

// Function to observe DOM changes for the upsell container
function observeUpsell() {
  const targetNode = document.querySelector('cart-drawer');
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (document.querySelector('[data-name="upsell"]')) {
        toggleUpsellVisibility();
        upsellNavigation();
        // observerInstance.disconnect();
      }
    });
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
}
observeUpsell();

window.onload = function () {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );
};

// ! Old version logic - upsell -> start
// function toggleUpsellVisibility() {
//   setTimeout(() => {
//     if (document.querySelector('[data-name="upsell"]')) {
//       if (!document.querySelector(".upsell__item")) {
//         document.querySelector('[data-name="upsell"]').classList.add("hidden");
//       } else {
//         document.querySelector('[data-name="upsell"]').classList.remove("hidden");
//       }
//     } else {
//       return;
//     }
//   }, 1500);
// }

// window.onload = setTimeout(() => {
//   document.documentElement.dispatchEvent(
//     new CustomEvent("cart:refresh", {
//       bubbles: true,
//     })
//   );
// }, 2500);

// function upsellNavigation() {
//   setTimeout(() => {
//     const productContainer = document.querySelector(".upsell__slider") ? document.querySelector(".upsell__slider") : null;
//     const nxtBtn = document.querySelector(".nxt-btn");
//     const preBtn = document.querySelector(".pre-btn");
//     const uspellBtns = document.querySelector('[data-name="upsell-buttons"]');
//     var upsellCartItems = document.querySelectorAll(".upsell__item");


//     if (productContainer) {
//       nxtBtn.addEventListener("click", function () {
//         productContainer.scrollLeft += 240;
//       });
//       preBtn.addEventListener("click", function () {
//         productContainer.scrollLeft -= 240;
//       });


//       const ele = document.querySelector(".upsell__slider");
//       let pos = { top: 0, left: 0, x: 0, y: 0 };

//       const mouseDownHandler = function (e) {
//         ele.style.cursor = "grabbing";
//         ele.style.userSelect = "none";

//         pos = {
//           // The current scroll
//           left: ele.scrollLeft,
//           // Get the current mouse position
//           x: e.clientX,
//         };

//         document.addEventListener("mousemove", mouseMoveHandler);
//         document.addEventListener("mouseup", mouseUpHandler);
//       };

//       const mouseMoveHandler = function (e) {
//         // How far the mouse has been moved
//         const dx = e.clientX - pos.x;
//         // Scroll the element
//         ele.scrollLeft = pos.left - dx * 2;
//       };

//       const mouseUpHandler = function () {
//         document.removeEventListener("mousemove", mouseMoveHandler);
//         document.removeEventListener("mouseup", mouseUpHandler);
//         ele.style.cursor = "grab";
//         ele.style.removeProperty("user-select");
//       };
//       ele.addEventListener("mousedown", mouseDownHandler);

//       const upsellSlideCartItems = document.querySelectorAll(".upsell__slider .upsell__item");
//       if (upsellSlideCartItems.length == 1) {
//         document.querySelector(".upsell").classList.add("one-item-in-cart");
//       } else if (upsellSlideCartItems.length < 1) {
//         document.querySelector(".upsell").classList.add("no-item-in-cart");
//       } else {
//         document.querySelector(".upsell").classList.remove("one-item-in-cart");
//         document.querySelector(".upsell").classList.remove("no-item-in-cart");
//       }

//       upsellCartItems.forEach((item) => {
//         const productTitle = item.querySelector(".upsell__product-name a").textContent;
//         const productColor = item.querySelector(".upsell__product-color").textContent.trim();
//         if (productTitle.length > 13) {
//           item.querySelector(".upsell__product-name a").textContent = productTitle.substring(0, 13) + '…';
//           item.querySelector(".upsell__product-name a").textContent = item.querySelector(".upsell__product-name a").textContent.replace(' …', '…');
//         }
//         if (productColor.length > 13) {
//           item.querySelector(".upsell__product-color").textContent = productColor.substring(0, 13) + '…';
//           item.querySelector(".upsell__product-color").textContent = item.querySelector(".upsell__product-color").textContent.replace(' …', '…');
//         }
//       })

//       function removeDuplicates() {
//         if (upsellCartItems.length <= 3) {
//           uspellBtns.classList.add("hidden");
//         } else {
//           uspellBtns.classList.remove("hidden");
//         }
//         const upsellItems = document.querySelectorAll(".line-item");
//         const uniqueItems = [];
//         upsellItems.forEach((item) => {
//           if (!uniqueItems.includes(item.getAttribute("value"))) {
//             uniqueItems.push(item.getAttribute("value"));
//           } else {
//             if (document.querySelector(`.line-item.${item.getAttribute("value")}`)) {
//               document.querySelector(`.line-item.${item.getAttribute("value")}`).classList.add("removed")
//               document.querySelector(`.line-item.${item.getAttribute("value")}`).remove();
//             }
//           }
//         });
//       }
//       removeDuplicates();
//     }
//   }, 1700);
// }
// upsellNavigation();
// ! Old version logic - upsell -> start


